import _ from '@/utils/lodash-optimized'
import { createSelector } from 'reselect'

import { getGlobalVarsClients } from './client.js'

const EMPTY_ARRAY = []

export const getUserAuthData = redux => redux?.auth?.profile

const getUserRoles = createSelector(getUserAuthData, data => {
  return data?.app_metadata?.roles?.meta?.role ?? ''
}
)

const getAllUserClients = createSelector(getUserAuthData, data => {
    if (!data?.app_metadata?.roles) {
        return EMPTY_ARRAY
    }
    return _.chain(data)
        .get('app_metadata.roles')
        .keys()
    .uniq()
    .map(client => _.first(_.split(client, '-compassion')))
    .value()
})

export const getOnlyAvailableUserClients = createSelector(
  [ getAllUserClients, getGlobalVarsClients ],
  (allClients, availableClients) => {
    return availableClients.filter(c => allClients.includes(c.clientName))
  }
)

export const hasAdminRole = createSelector(
  getUserRoles,
  role =>
    role === 'administrator' ||
    role === 'executive_director' ||
    role === 'medical_director'
)
